<template>

	<router-view
		v-if="groupIsAvailable"
	/>

	<template v-else>
		<v-card
			class="d-flex h-100"
		>
			<div class="ma-auto">
				<CompanyNoLicense
					noAccessToGroup
				/>
			</div>
		</v-card>
	</template>

</template>

<script setup>
import { ref, watch } from 'vue'
import { storeToRefs } from 'pinia'

import CompanyNoLicense from '@/components/company/CompanyNoLicense.vue'

import useRouts from '@/composables/useRouts'

import { useCompanyStore } from '@/stores/companyStore'

const {
	currentGroupName,
} = useRouts()

const companyStore = useCompanyStore()
const {
	availableRouteGroupsByCompanyLicense,
} = storeToRefs(companyStore)

const groupIsAvailable = ref(false)

const checkAvailability = (routeName) => {
	if (availableRouteGroupsByCompanyLicense.value.includes(routeName)) {
		groupIsAvailable.value = true
	} else {
		groupIsAvailable.value = false
	}
}

watch(currentGroupName, (value) => {
	checkAvailability(value)
}, {
	immediate: true,
})
</script>
